import React from 'react'
import qs from 'qs'
import { verifyEmail } from 'app/views/utils/auth'

const propTypes = {}
const defaultProps = {}

class VerifyEmail extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      error: null,
    }
  }

  componentDidMount() {
    const queryString = this.props.location.search.substr(1)
    const queryParams = qs.parse(queryString)

    verifyEmail({
      username: decodeURIComponent(queryParams.user_name),
      verificationCode: this.props.match.params.code,
    })
      .then(() => {
        this.props.history.push('/login')
      })
      .catch((err) => {
        if (err.message === 'User cannot be confirmed. Current status is CONFIRMED') {
          this.props.history.push('/login')
        } else {
          this.setState({
            error: err.message,
          })
        }
      })
  }

  render() {
    const {
      error,
    } = this.state

    return (
      <div className="uk-container">
        <div className="uk-section">
          <div className="uk-container">
            <div className="uk-text-center">
              {
                error
                  ? (<span>{error}</span>)
                  : (<div data-uk-spinner="" />)
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

VerifyEmail.propTypes = propTypes
VerifyEmail.defaultProps = defaultProps

export default VerifyEmail
